import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LangUpdateService {
  private currentLang = new BehaviorSubject<string>('');
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public currentLangChanged = this.currentLang.asObservable();

  public updateLanguage(lang: string) {
    this.currentLang.next(lang);
  }

  public register(instance: any, sub: (res: any) => void = null): Subscription {
    const subscribe = this.currentLangChanged.subscribe(lang => {
      sub(lang);
    });
    if (instance) {
      const originalDestroy = Object.getPrototypeOf(instance).ngOnDestroy;
      Object.getPrototypeOf(instance).ngOnDestroy = () => {
        if (originalDestroy) {
          try {
            originalDestroy.call(instance);
          }
          catch (ex) {
            // Empty
          }
        }
        subscribe.unsubscribe();
      };
    }
    return subscribe;
  }

  // TODO: This causes memory issues just like in the past for IPM. Needs to be refactored.
  public prepare(instance: any, translate: TranslateService, sub: (res: any) => void = null) {
    translate.currentLang = '';
    const subscribe = this.currentLangChanged.subscribe(lang => {
      translate.use(lang).subscribe((res) => {
        if (sub) {
          sub(res);
        }
      });
    });
    if (instance) {
      const originalDestroy = Object.getPrototypeOf(instance).ngOnDestroy;
      Object.getPrototypeOf(instance).ngOnDestroy = () => {
        if (originalDestroy) {
          try {
            originalDestroy.call(instance);
          }
          catch (ex) {
            // Empty
          }
        }
        subscribe.unsubscribe();
      };
    }
  }

  public log(translate: TranslateService) {
    const loader = translate.currentLoader as TranslateHttpLoader;
    console.log(loader.prefix + translate.currentLang + loader.suffix);
  }
}

export class TranslateHttpLoaderWithDefault extends TranslateHttpLoader {
  public constructor(http: HttpClient, prefix?: string, suffix?: string, private defaultLang: string = 'en') {
    super(http, prefix, suffix);
  }

  public getTranslation(lang: string): Observable<object> {
    return super.getTranslation(lang).pipe(
      catchError(() => super.getTranslation(this.defaultLang)
      ));
  }
}
